import { useEffect, useMemo } from 'react';

import { type RequestedResponder, type ResponderItem } from '../../common/types';
import { useResponderNamesStore } from '../responder-names-store';

export const useResponderNames = (requestedResponders: RequestedResponder[]): ResponderItem[] => {
	const [{ responders }, { batchResponders }] = useResponderNamesStore();

	const memoizedResponders = useMemo(() => {
		return requestedResponders.map((responder) => {
			return (
				responders[responder.id] ?? {
					acknowledged: false,
					isError: false,
					isLoading: true,
					name: '',
					...responder,
				}
			);
		});
	}, [responders, requestedResponders]);

	useEffect(() => {
		batchResponders(requestedResponders);
	}, [requestedResponders, batchResponders]);

	return memoizedResponders;
};
